import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PortalSettingsService } from '@core/services/portal-settings.service';
import { NotificationsService } from '@core/services/notifications.service';
import { LoginFormService } from '@pages/account/services/login-form.service';
import { LoginCompanyInfo } from '@shared/model/login-company-info';
import { AccountApiService } from '@pages/account/services/account.api.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-kiosklogin',
  standalone: false,
  templateUrl: './kiosklogin.component.html',
  styleUrl: './kiosklogin.component.scss',
})
export class KioskloginComponent implements OnInit, OnDestroy {
  private readonly portalSettings = inject(PortalSettingsService).getPortalSettings();
  private readonly accountApiService = inject(AccountApiService);
  private readonly notificationsService = inject(NotificationsService);
  private readonly loginFormService = inject(LoginFormService);

  loginForm = new FormGroup({
    companySelect: new FormControl(null),
    employeeNum: new FormControl(null, Validators.required),
    password: new FormControl(null, Validators.required),
  });

  welcomeText = this.portalSettings.LoginWelcomeRichText.ConfigValue;
  kioskDisabled = this.portalSettings.TCDisableNonPassKiosk.ConfigValue == '1';
  capsLockOn = false;
  companyConfig: LoginCompanyInfo;
  isLoading: boolean;
  kioskLoginSubscription: Subscription;
  getCompanyConfigSubscription: Subscription;

  ngOnInit(): void {
    document.body.style.backgroundImage = "url('/Cache/images/trimble-background.png')";
    if (this.kioskDisabled) {
      this.rerouteToHome();
    } else {
      this.configureCompanySelect();
    }
  }

  ngOnDestroy(): void {
    this.kioskLoginSubscription?.unsubscribe();
    this.getCompanyConfigSubscription?.unsubscribe();
  }

  clockinout(): void {
    this.isLoading = true;
    const loginErrorMsg =
      'Login failed - please confirm your information and retry. Note that repeated login attempts may lock your account.';

    this.kioskLoginSubscription = this.accountApiService
      .kioskLogin(this.loginForm.value.companySelect, this.loginForm.value.employeeNum, this.loginForm.value.password)
      .subscribe({
        next: response => {
          if (response.success) {
            window.location.href = '/Employee/ClockInOut?kioskLogin=true';
          } else {
            this.isLoading = false;
            this.notificationsService.showError(loginErrorMsg, window.location.pathname);
          }
        },
        error: err => {
          this.isLoading = false;
          this.notificationsService.showError(loginErrorMsg, window.location.pathname);
        },
      });
  }

  updateCompanyLogo(event: Event): void {
    const selectCoElement = event.target as HTMLSelectElement;
    if (this.companyConfig?.changeLogo && this.companyConfig?.isCoDropdownVisible) {
      this.companyConfig.logoUrl = this.loginFormService.getLogoUrl(Number(selectCoElement.value));
    }
  }

  configureCompanySelect(): void {
    this.getCompanyConfigSubscription = this.loginFormService.getCompanyConfiguration().subscribe(config => {
      this.companyConfig = config;

      // set form validation and value for company selection
      if (this.companyConfig.isCompanySelection) {
        this.loginForm.get('companySelect').setValidators(Validators.required);
      } else {
        this.loginForm.get('companySelect').clearValidators();
      }
      this.loginForm.controls['companySelect'].setValue(this.companyConfig.defaultCompany);
      this.loginForm.updateValueAndValidity();
    });
  }

  rerouteToHome(): void {
    setTimeout(() => {
      window.location.href = '/Home/Index';
    }, 5000);
  }
}
